/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/js/transparent-header.js ***!
  \**************************************/
/**
 * Header state: transparent (hero overlay) or solid oat (default, scrolled, search, megamenu).
 * Runs on all pages. Transparent only when .hero-overlay-header exists.
 */
(function () {
  function init() {
    var _document$querySelect, _document$querySelect2;

    var headerSection = document.getElementById('shopify-section-header') || ((_document$querySelect = document.querySelector('.site-header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('[id^="shopify-section"]'));
    var siteHeader = document.querySelector('.site-header');
    var wrapper = document.getElementById('header-sticky-wrapper');
    var row1 = document.getElementById('header-row1');
    var row2 = document.getElementById('header-row2');
    var DESKTOP_MIN = 1300;
    var scrollThreshold = 50;
    var uspSection = (_document$querySelect2 = document.querySelector('.js-usp-bar')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.closest('[id^="shopify-section"]');
    var isRow1Hidden = false;
    var cachedRow1Height = 0;
    var cachedRow2Height = 0;
    var cachedUspHeight = 0;
    var main = document.getElementById('MainContent');
    var firstSection = main && main.firstElementChild;
    var firstSectionHero = firstSection && firstSection.querySelector('.hero-overlay-header, [data-transparent-header], .loyalty-hero');
    var hasTransparentHero = !!firstSectionHero;
    var searchOpen = false;
    var headerHovered = false;
    var mobileMenuOpen = false;

    function setSolid(solid) {
      if (wrapper) {
        if (solid) wrapper.classList.add('header-solid');else wrapper.classList.remove('header-solid');
      }
    }

    function setTransparent(transparent) {
      if (transparent) {
        if (headerSection) headerSection.classList.add('header-transparent');
        if (siteHeader) siteHeader.setAttribute('data-transparent', 'true');

        if (wrapper) {
          var _document$querySelect3;

          wrapper.classList.add('header-transparent');
          var h = wrapper.offsetHeight;
          var uspSection = (_document$querySelect3 = document.querySelector('.js-usp-bar')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.closest('[id^="shopify-section"]');
          var uspH = uspSection ? uspSection.offsetHeight : 0;
          var headerH = headerSection ? headerSection.offsetHeight : 0;
          document.documentElement.style.setProperty('--hero-overlay-margin', '-' + h + 'px');
          document.documentElement.style.setProperty('--header-wrapper-height', headerH + 'px');
          document.documentElement.style.setProperty('--usp-bar-height', uspH + 'px');
        }
      } else {
        if (headerSection) headerSection.classList.remove('header-transparent');
        if (siteHeader) siteHeader.removeAttribute('data-transparent');

        if (wrapper) {
          wrapper.classList.remove('header-transparent');
          document.documentElement.style.removeProperty('--header-wrapper-height');
          document.documentElement.style.removeProperty('--usp-bar-height');
        }
      }
    }

    function cacheRowHeights() {
      if (!row1 || !row2 || window.innerWidth < DESKTOP_MIN) return; // Clear transforms so measurements reflect the natural layout

      var prevHeader = siteHeader ? siteHeader.style.transform : '';
      var prevUsp = uspSection ? uspSection.style.transform : '';
      if (siteHeader) siteHeader.style.transform = '';
      if (uspSection) uspSection.style.transform = '';
      cachedUspHeight = uspSection ? uspSection.getBoundingClientRect().height : 0;
      cachedRow1Height = row2.getBoundingClientRect().top - siteHeader.getBoundingClientRect().top;
      cachedRow2Height = row2.getBoundingClientRect().height;
      if (siteHeader) siteHeader.style.transform = prevHeader;
      if (uspSection) uspSection.style.transform = prevUsp;
    }

    function updateScrollHide() {
      if (!siteHeader || !row1 || !row2 || !wrapper) return;

      if (window.innerWidth < DESKTOP_MIN) {
        if (isRow1Hidden) {
          siteHeader.style.transform = '';
          if (uspSection) uspSection.style.transform = '';
          wrapper.style.height = '';
          isRow1Hidden = false;
        }

        return;
      }

      var shouldHide = window.scrollY > 10 && !searchOpen && !headerHovered;
      if (shouldHide === isRow1Hidden) return;
      isRow1Hidden = shouldHide;

      if (shouldHide) {
        // USP bar slides up by its own height; site-header slides up by row1 + usp combined
        if (uspSection) {
          uspSection.style.transition = 'transform 0.3s ease';
          uspSection.style.transform = 'translateY(-' + cachedUspHeight + 'px)';
        }

        siteHeader.style.transform = 'translateY(-' + (cachedRow1Height + cachedUspHeight) + 'px)';
        wrapper.style.height = cachedRow2Height + 'px';
        document.documentElement.classList.add('header-row1-hidden');
      } else {
        siteHeader.style.transform = '';
        if (uspSection) uspSection.style.transform = '';
        wrapper.style.height = '';
        document.documentElement.classList.remove('header-row1-hidden');
      }
    }

    function updateHeader() {
      var isSolid = window.scrollY > scrollThreshold || searchOpen || headerHovered || mobileMenuOpen;
      var isTransparent = hasTransparentHero && window.scrollY <= scrollThreshold && !isSolid;
      setSolid(isSolid);
      setTransparent(isTransparent);
      updateScrollHide();

      if (wrapper && hasTransparentHero) {
        var _document$querySelect4;

        var h = wrapper.offsetHeight;
        var uspSection = (_document$querySelect4 = document.querySelector('.js-usp-bar')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.closest('[id^="shopify-section"]');
        var uspH = uspSection ? uspSection.offsetHeight : 0;
        var headerH = headerSection ? headerSection.offsetHeight : 0;
        document.documentElement.style.setProperty('--hero-overlay-margin', '-' + h + 'px');
        document.documentElement.style.setProperty('--header-wrapper-height', headerH + 'px');
        document.documentElement.style.setProperty('--usp-bar-height', uspH + 'px');
      }
    }

    cacheRowHeights();
    updateHeader();
    /* Remove -initial only after real state is set to avoid black→white flicker */

    if (wrapper) wrapper.classList.remove('header-transparent-initial');
    if (siteHeader) siteHeader.removeAttribute('data-transparent-initial');
    window.addEventListener('scroll', updateHeader, {
      passive: true
    });
    window.addEventListener('resize', function () {
      isRow1Hidden = false;
      siteHeader.style.transform = '';
      if (uspSection) uspSection.style.transform = '';
      wrapper.style.height = '';
      cacheRowHeights();
      updateHeader();
    });

    if (wrapper) {
      wrapper.addEventListener('mouseenter', function () {
        headerHovered = true;
        updateHeader();
      });
      wrapper.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
        headerHovered = false;
        updateHeader();
      });
    }

    document.addEventListener('transparent-header-search', function (e) {
      searchOpen = !!e.detail;
      updateHeader();
    });
    document.addEventListener('transparent-header-mobile-menu', function (e) {
      mobileMenuOpen = !!e.detail;
      updateHeader();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/******/ })()
;